"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.settingsStore = void 0;
var settings_1 = require("./settings");
Object.defineProperty(exports, "settingsStore", { enumerable: true, get: function () { return settings_1.settingsStore; } });
//# sourceMappingURL=index.js.map